<!-- NUEVO FORMULARIO LTO -->
<body>
  <div class="container" [ngClass]="{'container--referrer': referrerPage && !successBack}">
    <header class="header">
      <img
        src="../../../assets/images/VEMO_IMPULSO.svg"
        alt="Logo Vemo Impulso"
      />
    </header>

    <main>
      <section class="details" *ngIf="!showConfirmationStep">
        <ng-container *ngIf="hidePageConfirmationPlatform; else documents">
          <div *ngIf="!referrerPage; else referrerText">
            <h2 class="text-title">
              Ingresa tus datos y te enviaremos una propuesta para que
              <div class="container-subtitle">
                <h2 class="text-subtitle">estrenes tu propio auto.</h2>
              </div>
            </h2>
          </div>
          <ng-template #referrerText>
            <h2 class="text-title">
              <div class="container-subtitle container-subtitle--referrer">
                <h2 class="text-subtitle">
                  ¡REFIERE Y GANA!
                </h2>
              </div>
              Solo compártenos los datos de tu referido
            </h2>
          </ng-template>
        </ng-container>
        <ng-template #documents>
          <div class="details-documents">
            <h2>Validación de perfil</h2>
            <h3>¡Cada vez más cerca de tu coche!</h3>
            <h4>
              Para continuar, carga los siguientes documentos que validarán tu
              perfil.
            </h4>
            <div class="container-alert" *ngIf="!hiddeAlert">
              <div class="container-text-alert">
                <mat-icon class="icon-error">report_problem</mat-icon>
                <p class="text-alert">
                  Recuerda cargar documentos o imágenes nítidas, con buena
                  iluminación, tomadas en fondo liso y superficie plana.
                  <strong>(Archivos permitidos: .JPEG, .PNG o .PDF)</strong>
                </p>
                <mat-icon class="icon-close" (click)="closeAlert()"
                  >highlight_off</mat-icon
                >
              </div>
            </div>
          </div>
        </ng-template>
      </section>

      <section class="more" *ngIf="!showConfirmationStep; else confirmationStep">
        <app-step-bienvenida-lto-nuevo
          *ngIf="hidePageConfirmationPlatform"
          [whereFindOutId]="whereFindOutId"
          (success)="showConfirmationStepEmit($event)"
        ></app-step-bienvenida-lto-nuevo>
        <app-step-documentos-lto-nuevo
          *ngIf="!hidePageConfirmationPlatform"
        ></app-step-documentos-lto-nuevo>
      </section>
      <ng-template #confirmationStep>
        <section class="details details--confirmation">
          <h2 *ngIf="successType === 'referrer'" class="text-title">
            ¡Gracias por referir! <br />
            Recuerda que entre más refieras, más ganas
            <div class="container-subtitle container-subtitle--referrer">
              <h2 class="text-subtitle">¡No hay límite!</h2>
            </div>
          </h2>
          <h2 *ngIf="successType === 'iaAgent'" class="text-title">
            ¡Gracias por completar tu solicitud! <br />
            Nuestro equipo se pondrá en contacto contigo pronto.
            <div class="container-subtitle">
              <h2 class="text-subtitle">¡Prepárate para estrenar tu auto!</h2>
            </div>
          </h2>
          <img src="assets/images/thank-you-referrer.svg" alt="Vemo Impulso" />
          <button *ngIf="successType === 'referrer'" class="boton-siguiente-lto" (click)="goToRefer()" mat-raised-button>
            Invita a alguien más
          </button>
        </section>
      </ng-template>
    </main>
  </div>
</body>
